import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
// State
import { SessionAuth } from "supertokens-auth-react/recipe/session";

interface AuthenticatedRouteProps {
  qr?: boolean | null;
  title: string;
  children: React.ReactNode;
}

const AuthenticatedRoute = ({
  qr,
  title,
  children,
}: AuthenticatedRouteProps) => {
  // Set the title of the browser tab
  useEffect(() => {
    document.title = `Lilli - ${title}`;
  });

  if (qr) {
    return <Navigate to={"/qr"} />;
  }
  return <SessionAuth>{children}</SessionAuth>;
};

export default AuthenticatedRoute;
